import React, { useContext, useEffect, useState } from "react";
import { Box, Stack, CardMedia } from "@mui/material";
import { contentBoxStyle, defaultLogoUrls, ThemeModeContext } from "../shared/Theme";
import Header from "../elements/Header";
import HubServiceCard from "../elements/Hub/HubServiceCard";
import HubInfoCard from "../elements/Hub/HubInfoCard";

const Hub = () => {

	const themeModeContext = useContext(ThemeModeContext);

	let [ infoVisibility, setInfoVisibility ] = useState({});
	let [ defaultLogo, setDefaultLogo ] = useState(defaultLogoUrls[themeModeContext.themeMode]);

	const toggleHelp = (name) => {
		let newVar = structuredClone(infoVisibility);
		newVar[name] = !newVar[name];
		setInfoVisibility(newVar);
	};
	
	useEffect(() => {
		setDefaultLogo(defaultLogoUrls[themeModeContext.themeMode]);
	}, [ themeModeContext ]);

	return (
		<Box sx={{ display: "flex" }}>
			<Box component="main" sx={{ flexGrow: 1, bgcolor: "background.default" }}>
				<Header pageTitle="Dashboard"/>
				<Box sx={contentBoxStyle}>
					<Stack
						direction="column"
						spacing={10}
						alignItems="center"
						justifyContent="center"
						sx={{ height: "100%" }}
					>
						<Stack
							direction="column"
							alignItems="center"
							justifyContent="center"
							spacing={2}
							sx={{ width: "80%", margin: "auto" }}
						></Stack>
						<Stack
							direction="column"
							alignItems="center"
							justifyContent="center"
							spacing={2}
							sx={{ width: "80%", margin: "auto" }}
						></Stack>
						<CardMedia
							component="img"
							src={defaultLogo}
							alt="company logo"
							sx={{ width: "219px", marginLeft: "2em" }}
						/>
						<Stack
							direction="column"
							alignItems="center"
							justifyContent="center"
							spacing={2}
							sx={{ width: "80%", margin: "auto" }}
						>
							<Stack
								direction="row"
								spacing={2}
								alignItems="center"
								justifyContent="center"
								sx={{ width: "100%", margin: "auto" }}
							>
								<Stack direction="column" spacing={2}>
									<HubServiceCard
										title="technology"
										isLocal={true}
										helpToggle={() =>
										{
											toggleHelp("technology");
										}}
										url="/dash"
									/>
								</Stack>
								<Stack direction="column" spacing={2}>
									<HubServiceCard
										title="people"
										isLocal={false}
										helpToggle={() =>
										{
											toggleHelp("people");
										}}
										url="https://app.user-training.com/"
									/>
								</Stack>
								<Stack direction="column" spacing={2}>
									<HubServiceCard
										title="process"
										isLocal={false}
										helpToggle={() =>
										{
											toggleHelp("process");
										}}
										url="https://process.cymplify-app.com"
									/>
								</Stack>
							</Stack>
							<Stack
								direction="row"
								spacing={2}
								alignItems="center"
								justifyContent="center"
								sx={{ width: "100%", margin: "auto" }}
							>
								<HubInfoCard
									title="Pillar 1 - Technology"
									isVisible={infoVisibility["technology"]}
								>
									<h5 sx={{ textAlign: "center" }}>Click to access:</h5>
									<ul>
										<li>
											Dashboard view of entire system(including People &
											Process info)
										</li>
										<li>
											Cyber Risk Exposure Monitoring Data and Remediation
											Guidance
										</li>
										<li>Dark Web Breach Exposure Data</li>
										<li>Vulnerability Scan Reports</li>
										<li>Additional Services</li>
										<li>Report Generator</li>
									</ul>
								</HubInfoCard>
								<HubInfoCard
									title="Pillar 2 - People"
									isVisible={infoVisibility["people"]}
								>
									<h5 sx={{ textAlign: "center" }}>Click to access:</h5>
									<ul>
										<li>
											Cyber Awareness Training - incl delivery, automation and
											ongoing management
										</li>
										<li>
											Simulated Phishing - incl delivery, automation and
											ongoing management
										</li>
										<li>
											Policy creation, delivery, automation and signature
											tracking
										</li>
										<li>
											Dark Web Breach Monitoring - in depth User Data and
											management
										</li>
										<li>Full Reporting</li>
									</ul>
								</HubInfoCard>
								<HubInfoCard
									title="Pillar 3 - Process"
									isVisible={infoVisibility["process"]}
								>
									<h5 sx={{ textAlign: "center" }}>Click to access:</h5>
									<ul>
										<li>
											Asset Management platform - record, detail and maintain
											all IT Assets, Users and Applications across the entire
											business
										</li>
										<li>
											Risk Register - Document, monitor and describe controls
											against your business risk in one place Maturity Score -
											built -in maturity dial and checklist to guide you by
											highlighting essential controls
										</li>
										<li>
											Easily achieve and maintain ongoing Compliance and
											Regulatory requirements
										</li>
									</ul>
								</HubInfoCard>
							</Stack>
						</Stack>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
};

export default Hub;
